export default "<p>rewards-deliverable works!</p>\n"